import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { MenuItem, MenuItemPath } from '@enums/menu-item.enum';
import { Observable, of } from 'rxjs';
import { catchError, map, first, mergeMap, tap } from 'rxjs/operators';
import { AuthService } from '../authentication/auth.service';
import { AccountService } from '../services/account.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authSrv: AuthService,
    private jwtHelperSrv: JwtHelperService,
    private accountService: AccountService
  ) { 
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.jwtHelperSrv.tokenGetter()) {
      this.authSrv.logout();
      return false;
    }

    // token valid and up to date
    if (this.authSrv.isAuth()) {
      return this.checkUser(next);
      // return true;
    }

    // Token exists but outdated
    return this.refreshToken(next);
  }

  private refreshToken(next: ActivatedRouteSnapshot): Observable<boolean> {
    return this.authSrv.refreshToken().pipe(
      mergeMap(() => {
        return this.checkUser(next).pipe(map(response => response));
        // return of(true);
      }),
      catchError(error => {
        this.authSrv.logout();
        return of(error);
      })
    );
  }

  checkUser(route: ActivatedRouteSnapshot): Observable<boolean> {
    if (!this.accountService.currentUser.value) {
      return this.accountService.getCurrentUser().pipe(map(() => {
        return this.checkUserRole(route);
      }));
    }
    return of(this.checkUserRole(route));
  }

  checkUserRole(route: ActivatedRouteSnapshot): boolean {
    const userRole = this.accountService.currentUser.value?.role_;
    if (route.data.role && route.data.role.indexOf(userRole) === -1) {
      this.router.navigate([MenuItemPath.get(MenuItem.home)]);
      return false;
    }
    return true;
  }
}


